import SpriteSymbol from "../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "corner-down-left",
  "use": "corner-down-left-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"corner-down-left\">\n<path d=\"M9,21c-0.3,0-0.5-0.1-0.7-0.3l-5-5c-0.4-0.4-0.4-1,0-1.4l5-5c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4L5.4,15l4.3,4.3\n\tc0.4,0.4,0.4,1,0,1.4C9.5,20.9,9.3,21,9,21z\" />\n<path d=\"M16,16H4c-0.6,0-1-0.4-1-1s0.4-1,1-1h12c0.8,0,1.6-0.3,2.1-0.9c0.6-0.6,0.9-1.3,0.9-2.1V4c0-0.6,0.4-1,1-1s1,0.4,1,1v7\n\tc0,1.3-0.5,2.6-1.5,3.5S17.3,16,16,16z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol